import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import PopularSection from './components/PopularSection';
import NewArrivalSection from './components/NewArrivalSection';
import { getFeaturedManga, getPopularManga, getNewArrivalManga } from '@/mocks/manga';

export default function Home() {
  const featuredManga = getFeaturedManga();
  const popularManga = getPopularManga();
  const newArrivalManga = getNewArrivalManga();

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '妖精漫画',
    url: 'https://qiyuah.cn/',
    description: '妖精漫画支持免费在线观看海量韩国漫画，下拉式大全整理有序，资源规模宏大，如同一个线上漫画博物馆，任您游览探索。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://qiyuah.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="妖精漫画 - 免费在线观看海量韩国漫画 - 下拉式韩漫大全"
        description="妖精漫画支持免费在线观看海量韩国漫画，下拉式大全整理有序，资源规模宏大，如同一个线上漫画博物馆，任您游览探索。涵盖热血、恋爱、奇幻、悬疑等多种题材韩漫。"
        keywords="妖精漫画,韩国漫画,韩漫,免费漫画,在线漫画,下拉式漫画,漫画大全"
        canonicalUrl="/"
        schema={schema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection mangaList={featuredManga} />
        <PopularSection mangaList={popularManga} />
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                为什么选择妖精漫画？
              </h2>
              <p className="text-sm text-foreground-500 mt-2">为漫画爱好者打造的最佳阅读平台</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-2xl text-primary-500"></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">海量资源</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">3200+部精选韩国漫画，持续更新扩充</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-download-cloud-2-line text-2xl text-accent-500"></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">完全免费</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">零门槛阅读，所有漫画免费在线观看</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-2xl text-secondary-500"></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">下拉式阅读</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">流畅下拉体验，完美适配韩漫画幅</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-primary-500"></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-900 mb-1">正版授权</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">与韩国多家漫画工作室合作授权</p>
              </div>
            </div>
          </div>
        </section>
        <NewArrivalSection mangaList={newArrivalManga} />
      </main>
      <Footer />
    </>
  );
}